import { render } from "./Email.vue?vue&type=template&id=edf3886c&scoped=true"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"

import "./Email.vue?vue&type=style&index=0&id=edf3886c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vizbi-frontend-test/vizbi-frontend-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edf3886c"]])

export default __exports__